import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { applyDocumentBranding } from './config/appConfig';
import store from './store';

const queryClient = new QueryClient();

applyDocumentBranding();

const readCspNonce = () => {
  if (typeof document === 'undefined') {
    return undefined;
  }

  const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content');

  return nonce || undefined;
};

const emotionCache = createCache({
  key: 'mui',
  nonce: readCspNonce(),
});

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <CacheProvider value={emotionCache}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </Provider>
    </CacheProvider>
  </React.StrictMode>,
);
